module.exports = __webpack_public_path__ + "img/img26.15db1be7.png";